import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { HttpService } from '@/features/api/http.service';
import type { IFeatureFlag } from '@/types/api';

const SYSTEM_PATH = '/';

const SYSTEM_FACTORY_NAME = 'system';

export const systemKeyFactory = createQueryKeys(SYSTEM_FACTORY_NAME, {
  getServerStatus: () => ({
    queryKey: [SYSTEM_PATH, 'health'],
    queryFn: () => HttpService.get<string, never>(`${SYSTEM_PATH}health`),
  }),
  getRemoteConfig: () => ({
    queryKey: [SYSTEM_PATH, 'config'],
    queryFn: () => HttpService.get<string, IFeatureFlag>(`${SYSTEM_PATH}config`),
  }),
});

export function useFeatureFlagQuery() {
  return useQuery({ ...systemKeyFactory.getRemoteConfig() });
}
